// @flow
import React, {useCallback, useEffect, useState} from 'react';

import {navigate} from '../../lib/helpers';
import {inspectionGibddCostApi} from '../../lib/api';
import {type InspectionGibddCost} from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import {InnerForm} from './components';
import {getBreadCrumbsByUrlForEdit} from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/inspection-gibdd-cost/';

export default (props: PageProps) => {
  const [data: InspectionGibddCost, setData] = useState({ id: props.id });

  useEffect(() => {
    // при создании новой записи, предзаполняем поля дефолтными значениями
    if (!props.id) {
      setData({
        ...data,
        interval_0_4: 0,
        interval_0_5: 12,
        interval_4_10: 24,
        interval_5_infinity: 6,
        interval_10_infinity: 12
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, data.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await inspectionGibddCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: InspectionGibddCost) => {
    let id = payload.id;
    if (id) {
      await inspectionGibddCostApi.update(payload);
    } else {
      let data = await inspectionGibddCostApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: InspectionGibddCost) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else {
      await navigate(`${entryPointPath}`, true);
    }
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость ТО ГИБДД'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
